//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TransientObject.js";
import "../no/Dimensions.js";
let d=[[[0,"AngularDimensionFormat",1,0],[0,"AngularToleranceFormat",1,0],[0,"ConvertPrimaryToleranceToDualDimensionUnit",1,0],[0,"DecimalPointCharacter",1,0],[0,"DimensionLeadingZero",1,0],[0,"DisplayTrailingZeros",1,0],[0,"DualDimensionCenterDimensionLine",1,0],[0,"DualDimensionPlacement",1,0],[0,"DualDimensionTextFormat",1,0],[0,"DualDimensionUnit",1,0],[0,"FractionalDisplay",1,0],[0,"NumeratorDegrees",1,0],[0,"NumeratorFraction",1,0],[0,"NumeratorMinutes",1,0],[0,"NumeratorSeconds",1,0],[0,"PrimaryDimensionTextFormat",1,0],[0,"PrimaryDimensionUnit",1,0],[0,"SuppressAngularZerosOption",1,0],[0,"ToleranceLeadingZero",1,0],[0,"TolerancePlacement",1,0]],[[[],"Dispose",{},0,0]],[]];
SPLM.Annotations.UnitsFormatPreferences = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.UnitsFormatPreferences";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;